module.exports = __webpack_public_path__ + "static/media/qd_monthly-report-2.40e8c210.png";